import ProxyList from '../views/agentManagement/proxyList'
import ExtensionLog from '../views/agentManagement/extensionLog'
// import DomainManagement from '../views/agentManagement/domainManagement'
// import DistrictProvider from '../views/agentManagement/districtProvider'
import PromotionHierarchy from '../views/agentManagement/promotionHierarchy'
import InvitationIncomeConf from '../views/agentManagement/invitationIncomeConf'
import Main from '../views/main'

const VideoRouter = {
  path: '/proxy-list',
  component: Main,
  title: '代理管理',
  icon: 'el-icon-s-cooperation',
  meta: { keepAlive: true },
  children: [
    {
      path: '/proxy-list',
      component: ProxyList,
      name: 'proxyList',
      title: '代理列表',
      meta: { title: '代理列表', keepAlive: true }
    },
    {
      path: '/invitation-income-conf',
      component: InvitationIncomeConf,
      name: 'InvitationIncomeConf',
      title: '邀请积分配置',
      meta: { title: '邀请积分配置', keepAlive: true }
    },
    // 暂时和落地页配置重复，待删除 TODO
    //{
    //  path: '/domain-management',
    //  component: DomainManagement,
    //  name: 'domainManagement',
    //  title: '域名管理',
    //  meta: { title: '域名管理'  ,keepAlive:true}
    //},
    {
      path: '/extension-log',
      component: ExtensionLog,
      name: 'extensionLog',
      title: '用户推广日志',
      meta: { title: '用户推广日志', keepAlive: true }
    },
    // {
    //   path: '/district-provider',
    //   component: DistrictProvider,
    //   name: 'districtProvider',
    //   title: '商区代理管理',
    //   meta: { title: '商区代理管理'  ,keepAlive:true}
    // },
    {
      path: '/promotion-hierarchy',
      component: PromotionHierarchy,
      name: 'promotionHierarchy',
      title: '用户推广查询',
      meta: { title: '用户推广查询', keepAlive: true }
    }
  ]
}
export default VideoRouter
